import { Kevel } from './kevel.js?v=2.1';
import { SelectPromotionEvent } from './select-promotion-event.js';

/**
 * Inicializa la sección slideshow-home con su ID único
 * @param {string} sectionId - El ID único de la sección de Shopify
 */
export function initSlideshowHome(sectionId) {
  const container = document.getElementById(`slideshow-home-${sectionId}`);

  if (!container) return;
  const newHomeSlider = {
    banners: {
      kevel: [],
      fdgo: [],
    },

    init: function () {
      const input = document.getElementById(`slideshow-home-banners-${sectionId}`);

      if (input != null) {
        const bannerUrls = input.value.split(',').filter((x) => x !== '');
        const bannerDesktopWidths = [375, 550, 750, 1100, 1500];

        bannerUrls.forEach((item) => {
          let data = item.split('|');
          let mobileAndTextContent = data[1].split('<>');
          let bannerUrlDesktop = data[0];
          let bannerUrlMobile = mobileAndTextContent[0];
          let bannerContent = mobileAndTextContent[1].split('&');
          let bannerData = [];
          let urlsDesktop = [];

          bannerContent.forEach((item) => {
            let datum = item.split('=');
            bannerData[datum[0]] = datum[1];
          });

          bannerDesktopWidths.forEach((size) => {
            urlsDesktop.push(`${bannerUrlDesktop}&width=${size} ${size}w`);
          });

          this.banners.fdgo.push({
            position: bannerData['position'],
            content: {
              title: bannerData['title'],
              subtitle: bannerData['subtitle'],
              ctaText: bannerData['cta_text'],
              url: bannerData['url'],
              backgroundColor: bannerData['bg_color'],
              textColor: bannerData['text_color'],
            },
            desktop: {
              src: `${bannerUrlDesktop}&width=3840`,
              srcset: urlsDesktop,
            },
            mobile: {
              src: bannerUrlMobile,
            },
          });
        });

        this.banners.fdgo.sort((a, b) => a.position - b.position);
      }
    },

    createSlide: function () {
      const homeSlider = container;
      const skeleton = homeSlider.querySelector('.slideshow-skeleton');
      const homeSliderPaddingTop = homeSlider.dataset.paddingTop;
      const homeSliderPaddingBottom = homeSlider.dataset.paddingBottom;

      let shell = homeSlider.querySelector(':scope > .slider-shell');
      if (!shell) {
        shell = document.createElement('div');
        shell.className = 'slider-shell';
        shell.style.height = homeSlider.offsetHeight + 'px';
        homeSlider.appendChild(shell);
        if (skeleton) shell.appendChild(skeleton);
      }

      const splide = document.createElement('section');
      splide.classList.add('splide', 'page-width', 'slider-enter');

      const splideArrows = document.createElement('div');
      const buttonPrev = document.createElement('button');
      const buttonNext = document.createElement('button');
      splideArrows.classList.add('splide__arrows');
      buttonPrev.classList.add('splide__arrow', 'splide__arrow--prev', 'arrow-button', 'arrow-button--prev');
      buttonNext.classList.add('splide__arrow', 'splide__arrow--next', 'arrow-button', 'arrow-button--next');
      buttonPrev.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 12L6 8L10 4" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      `;
      buttonNext.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12L10 8L6 4" fill="#ffffff" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      `;
      splideArrows.appendChild(buttonPrev);
      splideArrows.appendChild(buttonNext);

      const splideTrack = document.createElement('div');
      splideTrack.classList.add('splide__track', 'slide-track');

      const splideList = document.createElement('ul');
      splideList.classList.add('splide__list');

      let selectPromotionEvent = new SelectPromotionEvent();
      this.banners.kevel.forEach((bannerData, index) => {
        const splideSlide = document.createElement('li');
        splideSlide.classList.add('splide__slide');
        splideSlide.style.backgroundColor = bannerData.content.backgroundColor || '#EDE9E6';
        splideSlide.style.borderRadius = 0;

        const slideContent = document.createElement('a');

        if (bannerData.content.url === null) {
          slideContent.style.pointerEvents = 'none';
        } else {
          slideContent.href = bannerData.content.url;
        }

        slideContent.id = 'slide-content';
        Object.assign(slideContent.dataset, {
          bannerPromo: 'banner',
          bannerId: bannerData.flightId || null,
          bannerName: bannerData.name,
          creativeSlot: bannerData.creativeSlot,
          itemId: bannerData.itemId,
          bannerImg: bannerData.desktop.src || bannerData.mobile.src,
        });

        const slideMedia = document.createElement('div');
        slideMedia.id = 'slide-media';
        slideMedia.style.height = '100%';
        const slideMediaPicture = document.createElement('picture');
        slideMediaPicture.classList.add('picture');

        if (bannerData.mobile.src !== null) {
          const slideMediaPictureSource = document.createElement('source');
          slideMediaPictureSource.media = '(max-width: 749px)';
          slideMediaPictureSource.srcset = bannerData.mobile.src;
          slideMediaPictureSource.dataset.bannerPromo = 'slide';
          slideMediaPicture.appendChild(slideMediaPictureSource);
        }

        const img = document.createElement('img');
        img.src = bannerData.desktop.src;
        img.loading = 'lazy';
        img.sizes = '100vw';
        img.style.height = '100%';
        img.classList.add('image');

        if (bannerData.content.title != null) {
          slideContent.classList.add('slider-content');
          slideMedia.classList.add('slider-media');

          const slideText = document.createElement('div');
          slideText.classList.add('slider-text');
          slideText.style.color = bannerData.content.textColor || '#1E1A49';
          const slideTitle = document.createElement('span');
          slideTitle.classList.add('slider-text-title', 'big');
          const slideSubtitle = document.createElement('span');
          slideSubtitle.classList.add('slider-text-subtitle');
          const slideButton = document.createElement('a');
          slideButton.classList.add('button', 'button--secondary', 'slider-content-button');

          slideTitle.innerHTML = bannerData.content.title;
          slideSubtitle.innerHTML = bannerData.content.subtitle;
          slideButton.innerHTML = bannerData.content.ctaText;
          slideButton.href = bannerData.content.url;

          slideText.appendChild(slideTitle);
          slideText.appendChild(slideSubtitle);
          slideText.appendChild(slideButton);
          slideContent.appendChild(slideText);

          slideButton.addEventListener('click', function (e) {
            selectPromotionEvent.setData('banner', index, slideContent);
          });
        } else {
          img.style.width = '100%';
          slideContent.href = bannerData.content.url;

          splideSlide.addEventListener('click', function (e) {
            selectPromotionEvent.setData('banner', index, slideContent);
          });
        }

        slideMediaPicture.appendChild(img);
        slideMedia.appendChild(slideMediaPicture);
        slideContent.appendChild(slideMedia);
        splideSlide.appendChild(slideContent);
        splideList.appendChild(splideSlide);

        fdKevel.sendViewableImpression(splideSlide, bannerData);
      });

      this.banners.fdgo.forEach((bannerData, index) => {
        const splideSlide = document.createElement('li');
        splideSlide.classList.add('splide__slide');
        splideSlide.style.backgroundColor = bannerData.content.backgroundColor;
        splideSlide.style.borderRadius = 0;

        const slideContent = document.createElement('a');
        slideContent.href = bannerData.content.url;
        slideContent.classList.add('slider-content', 'page-width');
        slideContent.dataset.bannerPromo = 'banner';
        slideContent.dataset.bannerId = index;
        const slideMedia = document.createElement('div');
        slideMedia.classList.add('slider-media');
        const slideMediaPicture = document.createElement('picture');
        slideMediaPicture.classList.add('picture');

        const img = document.createElement('img');
        img.src = bannerData.desktop.src;
        img.srcset = bannerData.desktop.srcset.join();
        img.height = 328;
        img.loading = 'lazy';
        img.sizes = '100vw';
        img.classList.add('image');

        if (bannerData.mobile.src !== undefined) {
          const slideMediaPictureSource = document.createElement('source');
          slideMediaPictureSource.media = '(max-width: 749px)';
          slideMediaPictureSource.srcset = bannerData.mobile.src;
          slideMediaPictureSource.dataset.bannerPromo = 'slide';
          slideMediaPicture.appendChild(slideMediaPictureSource);
        }

        const slideText = document.createElement('div');
        slideText.classList.add('slider-text');
        slideText.style.color = bannerData.content.textColor;
        const slideTitle = document.createElement('span');
        slideTitle.classList.add('slider-text-title', 'big');
        const slideSubtitle = document.createElement('span');
        slideSubtitle.classList.add('slider-text-subtitle');
        const slideButton = document.createElement('a');
        slideButton.classList.add('button', 'button--secondary', 'slider-content-button');

        slideTitle.innerText = bannerData.content.title;
        slideSubtitle.innerText = bannerData.content.subtitle;
        slideButton.innerText = bannerData.content.ctaText;
        slideButton.href = bannerData.content.url;

        slideText.appendChild(slideTitle);
        slideText.appendChild(slideSubtitle);
        slideText.appendChild(slideButton);

        slideMediaPicture.appendChild(img);
        slideMedia.appendChild(slideMediaPicture);
        slideContent.appendChild(slideText);
        slideContent.appendChild(slideMedia);
        splideSlide.appendChild(slideContent);
        splideList.appendChild(splideSlide);
      });

      splideTrack.appendChild(splideList);
      splide.appendChild(splideArrows);
      splide.appendChild(splideTrack);
      splide.id = `slideshow-home-${sectionId}`;
      splide.style.paddingTop = homeSliderPaddingTop;
      splide.style.paddingBottom = homeSliderPaddingBottom;
      homeSlider.replaceWith(splide);

      const needArrowAndPagination = newHomeSlider.banners.fdgo.length + newHomeSlider.banners.kevel.length > 1;

      new Splide(splide, {
        type: 'slide',
        speed: 300,
        pagination: needArrowAndPagination,
        arrows: false,
        autoHeight: true,
        autoplay: 'pause',
        intersection: {
          inView: {
            autoplay: true,
          },
        },
        interval: 5000,
        rewind: needArrowAndPagination,
        rewindByDrag: needArrowAndPagination,
        flickPower: 450,
        pauseOnHover: true,
        mediaQuery: 'min',
        easing: 'cubic-bezier(.17,.67,.83,.67)',
        breakpoints: {
          750: {
            arrows: needArrowAndPagination,
          },
        },
      }).mount(window.splide.Extensions);

      void shell.offsetHeight;
      const targetHeight = splide.offsetHeight;
      shell.style.height = targetHeight + 'px';

      requestAnimationFrame(() => {
        splide.classList.add('slider-enter-active');
        if (skeleton) skeleton.classList.add('skeleton-out');
      });

      const onDone = (ev) => {
        if (ev.target !== shell || ev.propertyName !== 'height') return;
        shell.removeEventListener('transitionend', onDone);
        if (skeleton && skeleton.parentNode) skeleton.remove();
        shell.style.height = '';
        splide.classList.remove('slider-enter', 'slider-enter-active');
      };

      shell.addEventListener('transitionend', onDone);
    },
  };

  newHomeSlider.init();

  const fdKevel = new Kevel();
  fdKevel
    .setDivName(`slideshow-home-${sectionId}`)
    .load(
      [
        {
          divName: 'slideshow-1',
          networkId: 11757,
          siteId: 1303014,
          zoneIds: [329728],
          adTypes: [11416, 11282],
          eventIds: [40],
        },
        {
          divName: 'slideshow-2',
          networkId: 11757,
          siteId: 1303014,
          zoneIds: [335327],
          adTypes: [11416, 11282],
          eventIds: [40],
        },
        {
          divName: 'slideshow-3',
          networkId: 11757,
          siteId: 1303014,
          zoneIds: [335328],
          adTypes: [11416, 11282],
          eventIds: [40],
        },
      ],
      [`page=${window.location.pathname}`]
    )
    .onSuccess((ev) => {
      const data = ev.detail;

      for (const [key, value] of Object.entries(data.decisions)) {
        if (value === null) continue;

        const campaignContent = value.contents[0];
        newHomeSlider.banners.kevel.push({
          content: {
            title: campaignContent.data.ctTitle || null,
            subtitle: campaignContent.data.ctSubtitle || null,
            ctaText: campaignContent.data.ctCTAText || null,
            url: campaignContent.data.ctrawClick !== 'null' ? value.clickUrl : null,
            backgroundColor: campaignContent.data.ctBackgroundColor || null,
            textColor: campaignContent.data.ctTextColor || null,
          },
          desktop: {
            src: `https://static.adzerk.net/Advertisers/${campaignContent.data.ctDesktopImage}`,
          },
          mobile: {
            src: `https://static.adzerk.net/Advertisers/${campaignContent.data.ctMobileImage}`,
          },
          impressionUrl: value.impressionUrl || null,
          events: value.events || null,
          flightId: value.flightId || campaign.campaignId,
          name: campaignContent.data.ctcampaignName || 'none',
          creativeSlot: campaignContent.data.ctcreativeSlot || 'none',
          itemId: 'none',
        });

        fetch(value.impressionUrl);
      }
    })
    .onComplete(() => {
      newHomeSlider.createSlide();
    });
}
